<template>
  <div id="background" style="height: 100%;
    width: 100%;
    position:fixed;
    background: url(/static/images/monton.png) no-repeat center center;
    background-attachment: fixed;
    background-size: cover;
    height: 100vh;
    overflow: hidden;">


    <div id="main_container" style="height:70vh;width: 100%;transform:translateY(30%);overflow: scroll;">
      <div v-if="showAntiPopup">
        <!--防伪&商品信息开始  -->
        <div style="display: flex;justify-content: center;
                        /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;width: 100%;height: 50px;opacity: 1;">
          <div
            style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
            <p style="background: url(/static/images/barcode.png);background-size: cover;width: 30px;height: 30px;"></p>
          </div>
        </div>
        <div>
          <div class="modal-anti">
            <div style="margin-top: 6%;display: flex;flex-direction: column;text-align: left;">
              <div style="text-align: center;">
                <span style="color: white;font-size: 1.0rem;">欢迎进入AOE线下体验店，更多惊喜等您开启</span>
              </div>
              <div style="margin-top: 6px;">
                <span style="color: white;font-size: 0.9rem;">门店名称:&nbsp;&nbsp;</span>
                <span style="color: white;font-size: 0.9rem;" v-text="storeName"></span>
              </div>
              <div style="margin-top: 6px;">
                <span style="color: white;font-size: 0.9rem;">店长微信:&nbsp;&nbsp;</span>
                <span style="color: white;font-size: 0.9rem;" v-text="storeManagerName"></span>
              </div>
              <div style="margin-top: 6px;">
                <span style="color: white;font-size: 0.9rem;">联系方式:&nbsp;&nbsp;</span>
                <span style="color: white;font-size: 0.9rem;" v-text="storeManagerTel"></span>
              </div>

              <div v-if="showActivity"
                style="width: 100%;height: fit-content;display: flex;justify-content: center;align-items: center;">
                <div :disabled="isDisabled"
                  style="z-index: 11;;width: 200px;height: 35px;margin-top: 20px;background-color:rgb(56, 28, 40); border-radius: 20px;display: flex;align-items: center;"
                  @click="joinActivity">
                  <span style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;">领取积分</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- 防伪&商品信息结束 -->

      <!--商品介绍开始-->
      <div v-show="showStoreProduct">
        <div class="modal-product">
          <div style="display: flex;flex-direction: column;text-align: left;">
            <div style="text-align: center;">
              <span style="color: rgb(255, 178, 0);font-size: 1.0rem;">体验店推荐产品</span>
            </div>

            <div style="text-align: center;margin-top: 7px;position: relative;">

              <div style="width: 100%;height: 100%;text-align: center;">
                <van-swipe :autoplay="3000">
                  <van-swipe-item v-for="(image, index) in this.images" :key="index">
                    <img :src="image" style="width: 58%;width: 58%;text-align: center;" />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage"
                style="position:absolute;top: 0;left: 0;width:100%;height:100%">
                <script type="text/wxtag-template">
                  <div style="position:absolute;top: 0;left: 0;width:100%;height:100%"></div>
                </script>
              </wx-open-launch-weapp>

            </div>




          </div>
        </div>
      </div>
      <!--商品介绍结束-->


      <!--中奖成功弹框开始-->
      <div v-show="showSuccessTip">
        <div style="display: flex;justify-content: center;
                        /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;width: 100%;height: 50px;opacity: 1;">
          <div
            style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
            <p style="background: url(/static/images/star.png);background-size: cover;width: 30px;height: 30px;"></p>
          </div>
        </div>
        <div>
          <div class="modal-anti">
            <div style="margin-top: 6%;margin-left: 5%;display: flex;flex-direction: column;text-align: left;">

              <p style="color: white;font-size: 1.2rem;margin-top: 14px;text-align: center;" v-html="getScoreTip"></p>
              <p style="color: white;margin-top: 14px;text-align: center;">
                <span style="font-size: 2.2rem;color:rgb(217, 94, 76);font-weight: bold;" v-html="getScore"></span>
                <span style="font-size: 1.2rem;">积分</span>
              </p>
              <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId"
                :path="miniAppPage">
                <script type="text/wxtag-template">
                            <input type="button" value="前往商城" style="border: none;
                                                z-index: 0;
                                                color: white;
                                                padding: 8px 30px;
                                                text-align: center;
                                                text-decoration: none;
                                                display: block;
                                                font-size: 14px;
                                                border-radius: 20px;
                                                margin-left: 7%;
                                                margin-top: 25px;background-color:rgb(56, 28, 40);
                                                width: 200px;height: 35px;"/>
                        </script>
              </wx-open-launch-weapp>
            </div>
          </div>
        </div>
      </div>
      <!-- 中奖成功弹框结束 -->




      <!--中奖错误弹框开始  -->
      <div v-show="showErrorTip">
        <div style="display: flex;justify-content: center;
                        /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;width: 100%;height: 50px;opacity: 1;">
          <div
            style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
            <p style="background: url(/static/images/star.png);background-size: cover;width: 30px;height: 30px;"></p>
          </div>
        </div>
        <div>
          <div class="modal-anti">
            <div style="margin-top: 10%;margin-left: 5%;display: flex;flex-direction: column;text-align: left;">
              <p style="color: white;font-size: 1.1rem;;margin-top: 10px;text-align: center;" v-html="errorTip"></p>
              <wx-open-launch-weapp id="launch-btn" :appid="miniAppId" :username="miniAppOriginalId"
                :path="miniAppPage">
                <script type="text/wxtag-template">
              <input type="button" value="前往商城" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            margin-left: 7%;
                                                            margin-top: 25px;background-color:rgb(56, 28, 40);
                                                            width: 200px;height: 35px;"/>
                                    </script>
              </wx-open-launch-weapp>
            </div>
          </div>
        </div>
      </div>
      <!-- 中奖错误弹框结束 -->


      <!--活动规则开始-->
      <div v-show="showPopup">
        <div id="activityRule" class="modal" @click="closePopup()"></div>
        <div v-show="showPopup" style="display: flex;justify-content: center;
                        /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;width: 100%;height: 50px;opacity: 1;">
          <div v-show="showPopup"
            style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
            <p
              style="background: url(/static/images/info-circle-o.png);background-size: cover;width: 30px;height: 30px;">
            </p>
          </div>
        </div>
        <!--防伪&商品信息开始  -->
        <div v-show="showPopup" class="modal-content">
          <div style="margin-top: 6%;display: flex;flex-direction: column;text-align: left;">
            <p v-html="activityRule" style="margin-top:10px;color: white;"></p>
          </div>
        </div>


      </div>
      <!--活动规则结束-->
    </div>
    <div v-show="showRule" id="bottom_bar"
      style="position: absolute;bottom: 2rem;text-align: center;height: 20px;width: 100%;">
      <span style="text-align: center;color:#ffffff;" @click="openPopup">规则说明</span>
    </div>
  </div>
</template>


<style scoped>
/* 背景遮罩 */
.modal {
  position: fixed;
  /* 固定位置 */
  z-index: 0;
  /* 位于顶层 */
  left: 0;
  top: 0;
  width: 100%;
  /* 宽度全屏 */
  height: 100%;
  /* 高度全屏 */
  overflow: auto;
  /* 超出内容可滚动 */
}

/* 模态内容 */
.modal-content {
  overflow: auto;
  margin-left: 10%;
  margin-top: -25px;
  background-color: #fefefe;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 1px solid rgb(56, 28, 40);
  width: 80%;
  height: 300px;
  text-align: center;
  background-color: rgba(254, 251, 251, 0.2);
  z-index: 12;
  border-radius: 20px;
}

/* 模态内容 */
.modal-anti {
  overflow: auto;
  background-color: #fefefe;
  margin-left: 10%;
  margin-top: -25px;
  /* 上下自动，左右15% */
  padding: 25px;
  border: 1px solid rgb(56, 28, 40);
  width: 80%;
  height: 250px;
  text-align: center;
  background-color: rgba(254, 251, 251, 0.2);
  z-index: 12;
  border-radius: 20px;
}

.modal-product {
  overflow: auto;
  background-color: #fefefe;
  margin: 5% 0% 0% 10%;
  /* 上下自动，左右15% */
  padding: 12px;
  border: 1px solid rgb(56, 28, 40);
  width: 80%;
  height: 230px;
  text-align: center;
  background-color: rgba(254, 251, 251, 0.2);
  z-index: 12;
  border-radius: 20px;
}
</style>
<script>
import { getScoreConfig, getJSSDK, getWechatAuth, joinStoreActivity, registerByOpenId, getStoreInfo } from '../../api/api'
import wx from 'weixin-js-sdk'
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant-green';
// options 为可选参数，无则不传
Vue;
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      storeId: "",
      sign: "",
      activityRule: "",
      showRule: false,
      showActivity: false,
      eno: "",
      showStoreProduct: false,
      storeName: "",
      storeManagerName: "",
      storeManagerTel: "",
      authCode: "",
      deptId: 0,
      showPopup: false,
      userToken: "",
      showSuccessTip: false,
      showErrorTip: false,
      isDisabled: false,
      getScoreTip: "",
      getScore: "",
      shopUrl: "",
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
      showAntiPopup: true,
      antiQuery: false,
      errorTip: "抱歉<br/>此码已参与积分<br/>感谢您的支持",
      images: []
    };
  },
  methods: {
    async getRule() {
      await getStoreInfo(this.storeId, this.sign).then(res => {
        //当门店信息为空的情况下
        if (res == null
          || res.data == null
          || res.data.data == null
          || res.data.data.dept == null) {
          this.showActivity = false
          this.showRule = false
          alert("未获取到门店信息")
        } else {

          if (!res.data.data.dept.enabled) {
            alert("门店已停用")
            return;
          }
          this.eno = res.data.data.enterpriseNo
          this.storeName = res.data.data.dept.name
          this.storeManagerName = res.data.data.dept.storeName
          this.storeManagerTel = res.data.data.dept.mobile
          this.deptId = res.data.data.dept.companyId

          //显示门店推荐商品
          if (res.data.data.storeUrlList != null) {
            const storeImage = res.data.data.storeUrlList;
            this.images = []
            for (let i = 0; i < storeImage.length; i++) {
              if (storeImage[i].productPhone != "" || storeImage[i].productPhone != null) {
                this.images.push(storeImage[i].productPhone)
              }
            }
            this.showStoreProduct = true
          } else {
            this.showStoreProduct = false
          }


          //门店主数据有，但是没设置门店码活动
          if (res.data.data.storeMarketing == null
            || res.data.data.storeMarketing.qrIntegral == null
            || res.data.data.storeMarketing.qrIntegral == 0
          ) {
            this.showActivity = false
            this.showRule = false
          } else {
            const storeJoinCount = res.data.data.storeMarketing.dailyUpperLimit
            this.showActivity = true
            const activityRule = "<h4 id=\"5qmif\" style=\"text-align:center;\">规则说明</h4><p style=\"text-align:left;line-height:27px\"><font size=\"2.2\"><br/>1. 凡进入VALORE MONTON线下旗舰店，新老用户都可以扫门店营销码参与活动;<br/>2. 门店营销码每人每日只能参与一次;<br/>3. 门店营销码每日上限为" + storeJoinCount + "次;<br/>4. 扫码点击获取积分,可进入商城进行兑换;<br/>5. 最终解释权归VALORE MONTON所有。</font></p>";
            this.activityRule = activityRule
            this.showRule = true
          }

          const wechatAuth = sessionStorage.getItem("wechatAuth")
          if (wechatAuth == "true") {
            this.joinActivity()
            return;
          }
        }

      }).catch(err =>
        alert("获取门店信息异常" + err)
      )
      if (this.deptId > 0) {
        await this.getScoreConfig()
      }
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      sessionStorage.setItem("wechatAuth", true);
      getWechatAuth(encodeURIComponent(url), "wxbc22565b3e7a59fd", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getScoreConfig() {
      getScoreConfig(this.deptId).then(res => {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      })
    },
    async joinActivity() {
      this.isDisabled = true;
      if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
        this.getAuth()
        return;
      }
      await registerByOpenId(this.eno, this.authCode).then(res => {
        if (res.data.code == 200) {
          this.userToken = res.data.data.token;
        }else{
          alert("用户登录异常，原因："+res.data.message);
          return;
        }
      })


      const data = {
        storeId: this.storeId,
        sign: this.sign,
        authCode: this.authCode,
        userToken: this.userToken
      }
      await joinStoreActivity(data).then(res => {
        if (res.data.code == "200") {
          this.getScoreTip = "恭喜您获得" + res.data.data.giftValue + "积分"
          this.getScore = res.data.data.giftValue;
          this.showSuccessTip = true;
          this.showAntiPopup = false;
          this.showStoreProduct = false;
          this.showPopup = false;
          this.showErrorTip = false;

        } else if (res.data.code == "500001" || res.data.code == "500002") {
          if (res.data.code == "500001") {
            this.errorTip = "抱歉<br/>您今日已参与活动，请明日再来<br/>感谢您的支持"
          } else {
            this.errorTip = "抱歉<br/>此旗舰店已达最高参与次数,<br/>请明日再来,感谢您的支持"
          }
          this.showAntiPopup = false;
          this.showPopup = false;
          this.showStoreProduct = false;
          this.showErrorTip = true;
          this.showSuccessTip = false;
        } else {
          this.errorTip = res.data.msg
          this.showAntiPopup = false;
          this.showPopup = false;
          this.showStoreProduct = false;
          this.showErrorTip = true;
          this.showSuccessTip = false;
        }
      })
      this.isDisabled = false;
      sessionStorage.removeItem("wechatAuth");
    },
    openPopup() {
      this.showAntiPopup = false;
      this.showStoreProduct = false
      this.showPopup = true;
      this.showErrorTip = false;
      this.showSuccessTip = false;
    },
    closePopup() {
      this.showPopup = false;
      this.showAntiPopup = true;
      this.showStoreProduct = true
      this.showErrorTip = false;
      this.showSuccessTip = false;
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxbc22565b3e7a59fd").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.storeId = this.$route.query.id
    this.sign = this.$route.query.sign
    this.authCode = this.$route.query.wyAuthCode
    if (this.storeId == "" || this.storeId == undefined || this.sign == "" || this.sign == undefined) {
      alert("参数异常")
    } else {
      this.getWxJs()
      this.getRule()
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/MaiTeng/Store.vue